import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RequestoState {
  requestorDetails: any | [],
}

const initialState: RequestoState = {
  requestorDetails: [],
};

const requestorDetailsSlice = createSlice({
  name: "requestorDetailsSlice",
  initialState,
  reducers: {
    setRequestorDetails(state, action: PayloadAction<any | {}>) {
      state.requestorDetails = action.payload;
    },
  },
});

export const { setRequestorDetails } = requestorDetailsSlice.actions;
export default requestorDetailsSlice.reducer;